import { Tag } from "../../model/tag/Tag";
import { CreateTagDto } from "../../model/tag/dto/CreateTagDto";
import { DeleteTagDto } from "../../model/tag/dto/DeleteTagDto";
import { GetTagUsageDto } from "../../model/tag/dto/GetTagUsageDto";
import { GetTagUsageResponseDto } from "../../model/tag/dto/GetTagUsageResponseDto";
import { UpdateTagDto } from "../../model/tag/dto/UpdateTagDto";
import { AtiraApi } from "../AxiosClient";

export class TagAxios {
  static getTags() {
    return AtiraApi.get<Tag[]>("/tag").then(({ data }) => data);
  }

  static createTag(dto: CreateTagDto) {
    return AtiraApi.post<Tag>("/tag", dto).then(({ data }) => data);
  }

  static updateTag({ tagId, ...dto }: UpdateTagDto) {
    return AtiraApi.patch<Tag>(`/tag/${tagId}`, dto).then(({ data }) => data);
  }

  static getTagUsage(dto: GetTagUsageDto) {
    return AtiraApi.get<GetTagUsageResponseDto>(`/tag/${dto.tagId}/usage`).then(
      ({ data }) => data,
    );
  }

  static deleteTag(dto: DeleteTagDto) {
    return AtiraApi.delete<void>(`/tag/${dto.tagId}`).then(({ data }) => data);
  }
}
